import "./unmark-loaded-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";

import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

import { usePostMarkUnloaded } from "./hooks/use-post-mark-unloaded.ts";

export const MarkUnloadedModal = ({
	onClose,
	isOpen,
	poNumber,
}: {
	onClose: () => void;
	isOpen: boolean;
	poNumber: string;
}) => {
	const { markUnloadedAsync, isSavingMarkUnloaded } = usePostMarkUnloaded();
	const handleConfirm = async () => {
		await markUnloadedAsync(poNumber);
		onClose();
	};

	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"unmark-loaded-modal"}
			confirmDisabled={isSavingMarkUnloaded}
			confirmText={"Unmark Loaded"}
			confirmVariant={"danger"}
			onCancel={onClose}
			onClose={onClose}
			onConfirm={() => void handleConfirm()}
			showConfirmationButtons={true}
			title={`Unmark Shipment as Loaded`}
			type={"error"}
			width={346}
		>
			<LoadingSpinner isVisible={isSavingMarkUnloaded} />
			<div className={"unmark-loaded-content"}>
				<SvgIcon className={"unmark-loaded-icon"} icon={alertTriangle} />
				<p>
					This shipment will no longer be marked as loaded
					<br />
					and may need to be reprocessed before dispatch.
				</p>
			</div>
		</TraxModal>
	);
};
